<template>
<div>
    <back-to-top></back-to-top>

    <main-content></main-content>

    <stage-intro></stage-intro>

    <function-service></function-service>

    <advantage></advantage>

    <partner></partner>

    <footer-info></footer-info>

<!--    <vueToTop :type="10" ></vueToTop>-->
</div>
</template>

<script>
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import mainContent from './components/mainContent/mainContent'
import stageIntro from "./components/stageIntro/stageIntro";
import functionService from "./components/functionService/functionService";
import advantage from "./components/advantage/advantage";
import partner from "./components/partner/partner";
import footerInfo from "./components/footer/footerInfo";
import backToTop from "./components/backToTop/backToTop";

export default {
    components:{
        backToTop,
        partner,
        mainContent,
        stageIntro,
        functionService,
        advantage,
        footerInfo
    },
    data(){
      return{
          isComponents:true
      }
    },
    created() {
        document.title='鼎研科技'
    }
}
</script>

<style>
    .main-content {
        background: no-repeat center;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        -ms-background-size: cover;
        min-height: 50em;
        position: relative;
        height: 810px;
        width: 100%;
        overflow: auto;
    }

</style>
